<template>
  <div class="my-4 mx-3">
    <div v-if="drugNotFound" class="notFoundClass text-h6">
      Medication not found
    </div>

    <div v-if="listing" class="ma-1">
      <!-- <hidden drug info> -->
      <div v-if="admin">
        brand: {{ listing.is_brand }} <br />rxcui: {{ listing.rxcui }}
        <br />NCD: {{ listing.product_ndc }}
        <a :href="adminEditUrl + listing.product_ndc" target="_blank">(edit)</a>
      </div>
      <!-- </hidden drug info> -->

      <v-card color="" bordered flat class="pa-4 mb-4 gradCard">
        <div class="d-flex flex-row">
          <!--image column-->
          <div class="mx-2">
            <med-package-image
              :imageFile="listing.file"
              :productForm="listing.dosage_form"
              :maxHeight="200"
              :maxWidth="isXS ? 60 : 100"
            >
              <!-- :maxWidth="this.$vuetify.breakpoint.mdAndUp ? 125 : 80" -->
            </med-package-image>
          </div>
          <div class="d-flex flex-column pl-4">
            <med-icon-block
              :listing="listing"
              class=""
              :row="true"
            ></med-icon-block>
            <div
              :class="this.$vuetify.breakpoint.smAndUp ? 'text-h3' : 'text-h4'"
              class="d-inline d-sm-block my-1"
            >
              {{ listing.brand_name }}
            </div>
            <div class="mb-2 ml-1 caption">
              <div v-if="listing.variations && listing.variations.length > 1">
                <div v-for="variation in listing.variations" :key="variation">
                  {{ variation }}
                </div>
              </div>

              <div v-else-if="showSynonym">
                {{ concToPercent(listing.synonym) }}
              </div>
            </div>

            <med-company-dialog
              :name="listing.manufacturer"
              :labeler_ndc="listing.labeler_ndc"
              titleClass="text-h6"
            ></med-company-dialog>

            <similar-meds-dialog
              :currentCompany="listing.manufacturer"
              :currentMed="listing.brand_name"
              :similarMeds="listing.similarDrugs"
              v-if="listing.similarDrugs && listing.similarDrugs.length"
            >
            </similar-meds-dialog>
          </div>
        </div>
      </v-card>
      <div>
        <!-- :class="{ 'd-flex flex-row flex-wrap': !isXS }" -->
        <v-simple-table dense class="tableStyle my-3">
          <!--  :class="{ narrowTable: showGoodRx }" -->
          <template v-slot:default>
            <tbody
              v-if="
                listing.activeIngredients && listing.activeIngredients.length
              "
            >
              <tr v-if="isXS">
                <th>Active Ingredients</th>
              </tr>
              <tr>
                <th v-if="!isXS">Active Ingredients</th>
                <td>
                  <med-item-list
                    title=""
                    :items="listing.activeIngredients"
                    key1="strength"
                    key2="name"
                  >
                  </med-item-list>
                </td>
              </tr>
            </tbody>

            <tbody
              v-if="
                listing.inactiveIngredients &&
                listing.inactiveIngredients.length
              "
            >
              <tr v-if="isXS">
                <th>Inactive Ingredients</th>
              </tr>
              <tr v-if="!isXS">
                <th>Inactive Ingredients</th>
                <td>
                  <med-item-list
                    :items="listing.inactiveIngredients"
                    key1="description"
                  >
                  </med-item-list>
                </td>
              </tr>
            </tbody>

            <tbody v-if="listing.pharmClasses && listing.pharmClasses.length">
              <tr v-if="isXS">
                <th>
                  Pharmacologic Class<span
                    v-if="listing.pharmClasses.length > 1"
                    >es</span
                  >
                </th>
              </tr>
              <tr>
                <th v-if="!isXS">
                  Pharmacologic Class<span
                    v-if="listing.pharmClasses.length > 1"
                    >es</span
                  >
                </th>
                <td>
                  <med-item-list :items="listing.pharmClasses" key1="name">
                  </med-item-list>
                  <more-details-dialog
                    title="Class &amp; Ingredient Definitions"
                    :items="listing.activeIngredients"
                    :categoryInfo="listing.categoryInfo"
                  >
                  </more-details-dialog>
                </td>
              </tr>
            </tbody>
            <tbody v-if="listing.packaging">
              <tr v-if="isXS">
                <th>Packaging</th>
              </tr>
              <tr>
                <th v-if="!isXS">Packaging</th>
                <td>
                  <div>
                    <package-list
                      :packagingArr="listing.packaging"
                      class="my-1 pb-2"
                    ></package-list>
                  </div>
                </td>
              </tr>
            </tbody> </template
        ></v-simple-table>
        <!-- <div v-if="goodRxSrc && showGoodRx" class="mx-auto">
          <iframe
            @load="goodRxLoaded()"
            :src="goodRxSrc"
            class="goodRxIframe mx-auto ma-2 pa-2"
            ref="goodRxIframe"
          ></iframe>
        </div> -->
      </div>

      <v-simple-table dense class="tableStyle mt-2" v-if="synopsisContent">
        <template v-slot:default>
          <tr>
            <th :colspan="isXS ? 1 : 2" class="titleTH">
              <div class="title">Medication Synopsis <sup>*</sup></div>
            </th>
          </tr>
          <tbody v-for="contentKey in synopsisHeaders" :key="contentKey">
            <template>
              <tr v-if="synopsisContent[contentKey] && isXS">
                <th>
                  {{ contentKey | titleize }}
                  <pregnancy-class-info
                    v-if="contentKey == 'pregnancy'"
                    :preg_letter="listing.synopsis.preg_letter"
                  ></pregnancy-class-info>
                </th>
              </tr>
              <tr v-if="synopsisContent[contentKey]">
                <th v-if="!isXS">
                  {{ contentKey | titleize }}
                  <pregnancy-class-info
                    v-if="contentKey == 'pregnancy'"
                    :preg_letter="listing.synopsis.preg_letter"
                  ></pregnancy-class-info>
                </th>
                <td :class="{ highlight: contentKey == 'dosage' }" class="py-2">
                  <vue-markdown
                    v-for="(li, i) in synopsisContent[contentKey]"
                    :key="contentKey + i"
                    class="mb-1"
                    >{{ li }}
                  </vue-markdown>
                  <!-- adapt to use markdown.. -->
                </td>
              </tr></template
            >
          </tbody>
        </template></v-simple-table
      >
      <div v-if="synopsisContent" class="caption">
        <sup>*</sup> This synopsis describes general prescribing recommendations
        for the current drug type, collected from the FDA listings and other
        curated sources. The information contained in the official FDA listings
        (below) supersedes the contents of this synopsis.
      </div>
    </div>

    <div v-if="listingApiResponse" class="my-3">
      <fda-listing-sections
        :fdaListing="listingApiResponse.results"
        :errors="listingApiResponse.errors"
      ></fda-listing-sections>
    </div>
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import HashParserMixin from "@/assets/js/HashParserMixin";
import VueMarkdown from "@adapttive/vue-markdown";
import ConcToPercentMixin from "@/assets/js/meds/ConcToPercentMixin";

export default {
  name: "MedDetails",
  components: {
    PackageList: () => import("@/components/medStuff/PackageList.vue"),
    FdaListingSections: () =>
      import("@/components/medStuff/FdaListingSections.vue"),
    MedIconBlock: () => import("@/components/medStuff/MedIconBlock.vue"),
    MedPackageImage: () => import("@/components/medStuff/MedPackageImage.vue"),
    MedCompanyDialog: () =>
      import("@/components/medStuff/MedCompanyDialog.vue"),
    SimilarMedsDialog: () =>
      import("@/components/medStuff/SimilarMedsDialog.vue"),
    MedItemList: () => import("@/components/medStuff/MedItemList.vue"),
    MoreDetailsDialog: () =>
      import("@/components/medStuff/MoreDetailsDialog.vue"),
    PregnancyClassInfo: () =>
      import("@/components/medStuff/PregnancyClassInfo.vue"),
    VueMarkdown,
  },
  mixins: [HashParserMixin, ConcToPercentMixin],
  props: {},

  data: function () {
    return {
      // viewedDisclaimer: true,
      admin: false,
      medId: null,
      listing: null,
      listingApiResponse: null,
      loading: null,
      showGoodRx: true,
      // iFrameHeight: 0,
      drugNotFound: false,
      medDetailsApi: "/meds/details/",
      medNdcApi: "/meds/ndc/",
      medRxcuiApi: "/meds/rxcui/",
      goodRxURL: "https://www.eyedock.com/goodRx.php?med=",
      goodRxNdcURL: "https://www.eyedock.com/goodRx.php?med=",
      adminEditUrl:
        "https://www.eyedock.com/fdaMeds/admin/editListings.php?ndc=",
      synopsisHeaders: [
        "dosage",
        "indications",
        "pediatric",
        "pregnancy",
        "contraindications",
        "note",
      ],
    };
  },
  methods: {
    callMedDetailsAPI(searchTerm, api = "medDetailsApi") {
      this.loading = true;
      /* ApiServices.medDetails(searchTerm) */
      ApiServices.genericApiCall(this[api] + encodeURIComponent(searchTerm))
        .then((response) => {
          let listing = response.data.listing;
          if (listing.id) {
            this.listing = listing;
            // if (listing.product_ndc) this.product_ndc = listing.product_ndc;
            this.callFdaListingApi();
          } else {
            this.drugNotFound = true;
          }

          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    callFdaListingApi() {
      if (!this.listing?.product_ndc) return;
      if (this.listingApiResponse) return;
      ApiServices.listingDataForNdc(this.listing.product_ndc)
        .then((response) => {
          // console.log(response);
          this.listingApiResponse = response.data;
          // this.getMoreInfo();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goodRxLoaded() {
      let frame = this.$refs.goodRxIframe;
      let sh = frame.contentWindow.document.body.scrollHeight;
      this.showGoodRx = sh > 50;
    },
  },
  computed: {
    isXS: function () {
      return !this.$vuetify.breakpoint.smAndUp;
    },
    showSynonym: function () {
      if (!this.listing.synonym) return false;
      return (
        this.listing.brand_name.toLowerCase() !=
        this.listing.synonym.toLowerCase()
      );
    },

    pageTitle: function () {
      let prefix = "EyeDock/Meds | ";
      let drugName = this.listing?.brand_name
        ? this.listing.brand_name
        : "Details";
      return prefix + drugName;
    },

    /*
goodRxSrc: function () {
    let src = "";
    if (this.listing?.brand_name)
      src = this.goodRxURL + this.listing.brand_name;
    return src;
  },
*/

    synopsisContent: function () {
      let c = this.listing?.synopsis?.content;
      // console.log(c);
      if (!c || !c.dosage) return null;
      return c;
    },

    // todo - just have the API return the labeler_ndc
    // labeler_ndc: function() {
    //   let product_ndc = this.listing?.product_ndc;
    //   var ndc = product_ndc.substr(0, product_ndc.indexOf("-"));
    //   return ndc ? ndc : null;
    // },
  },
  mounted: function () {
    // this.viewedDisclaimer = this.$cookies.get("viewedDisclaimer", true);

    // look for admin key in the hash (calls function in hashParserMixin)
    // if true will display med ndc and other otherwise hidden data
    this.admin = this.hashValForKey("admin");

    let medId = this.$route.params.id;
    let medName = this.$route.params.name;
    let ndc = this.$route.params.ndc;

    let searchTerm = medId;
    if (ndc) {
      this.callMedDetailsAPI(ndc, "medNdcApi");
    } else {
      if (!medId && medName) searchTerm = medName;
      if (searchTerm) this.callMedDetailsAPI(searchTerm);
    }
    // todo - display something if no searches are done
  },
  metaInfo() {
    return {
      title: this.pageTitle,
    };
  },
};
</script>

<style scoped>
.partialWidth {
  min-width: 40%;
  max-width: 450px;
  padding: 0 1em;
}
.fullwidth {
  min-width: 100%;
}

.goodRxIframe {
  width: 300px;
  height: 180px;
  border: none;
}

.notFoundClass {
  margin-left: 30%;
  margin-top: 50px;
  padding: 20px;
  width: 300px;
  text-align: center;
  border-radius: 2px;
  background-color: yellow;
}

th {
  background-color: #ecf6fd;
  font-size: 15px !important;
  color: #525252;
  width: 200px;
}
table,
table td,
table th {
  border: 0.5px solid #bbd4e4;
}
.tableStyle {
  border: 1px solid #b5c9d7;
}
.highlight {
  background-color: #fff0d9 !important;
}
.titleTH {
  background-color: #b3ddfc;
}
.gradCard {
  background-image: linear-gradient(136deg, #fff 40%, #e3f2fd);
  border: 1px solid #b5c9d6;
}
.narrowTable {
  max-width: 600px;
}
/* .thClass {
  background-color: #ecf6fd;
  color: #525252;
  padding: 2px 5px;
  width: 100% !important;
} */
</style>
